import { Button } from '@mui/material';

interface AddAccountButtonProps {
  label: string;
  onClick: () => void;
}

export default function AddAccountButton({ label, onClick }: AddAccountButtonProps) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor: '#465fff',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#3641f5',
        },
      }}
    >
      {label}
    </Button>
  );
}

